import InputLabel from 'components/inputfields/InputLabel';
import IProduct, { AnimalFeedTypeEnum } from 'models/product';
import { IFoodlaCategoryOption } from 'models/category';

import ListDropDown from 'components/inputfields/ListDropDown';
import { animalFeedTypes } from 'components/constants-ts';

interface AnimalFeedTypeProps {
  readOnly?: boolean;
  state: IProduct;
  setState: (state: IProduct | ((prevState: IProduct) => IProduct)) => void;
  rootCategory?: IFoodlaCategoryOption;
}

const AnimalFeedType = ({ readOnly, state, setState }: AnimalFeedTypeProps) => {
  return (
    <div style={{ width: '100%' }}>
      <InputLabel
        heading="Djurfodertyp"
        text="Välj typ av foder enligt märkningskraven. Helfoder täcker djurets dagliga näringsbehov. Kompletteringsfoder måste kombineras med annat foder."
        link="https://jordbruksverket.se/djur/foder-och-produkter-fran-djur/foder/producera-och-hantera-foder-pa-lantbruk-och-annan-primarproduktion"
      />
      <ListDropDown
        readOnly={readOnly}
        listData={animalFeedTypes}
        targetName="animalFeedType"
        value={state?.animalFeedType}
        handleChange={({ target }) =>
          setState(oldState => ({ ...oldState, animalFeedType: target.value as AnimalFeedTypeEnum }))
        }
      />
    </div>
  );
};

export default AnimalFeedType;
